// import Flickity from 'flickity';
Flickity.prototype._createResizeClass = function() {
    this.element.classList.add('flickity-resize');
};

var resize = Flickity.prototype.resize;
Flickity.prototype.resize = function() {
    this.element.classList.remove('flickity-resize');
    resize.call( this );
    this.element.classList.add('flickity-resize');
};
if (!customElements.get('announcement-slider')) {
    customElements.define('announcement-slider', class AnnouncementSlider extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                slider: ".js-announcement-slider",
                sliderScrolling: ".js-announcement-slider-scrolling",
                nextSlideToggle: ".js-announcement-slider-nav-next",
                prevSlideToggle: ".js-announcement-slider-nav-prev"
            };
            this.slider = this.querySelector(this.selectors.slider);
            this.sliderScrolling = this.querySelector(this.selectors.sliderScrolling);
            this.nextSlideToggle = this.querySelector(this.selectors.nextSlideToggle);
            this.prevSlideToggle = this.querySelector(this.selectors.prevSlideToggle);
            this.init();
        }

        init() {
            this.initSlider();

            // Section loaded in Theme Editor
            document.addEventListener('shopify:section:load', function(event) {
                const $parent = $(event.target);
                let check = $parent.find(`${parent}`);
                if (check.length > 0) {
                    if (this.slider != null) {
                        this.slider.destroy();
                        this.initSlider();
                    }
                }
            });
        }

        setupSlider(slider) {
            let index = 0;
            const slides = slider.element.querySelectorAll('.js-lsg-announcement-slider-item');
            slides.forEach((el) => {
                index++;
                el.setAttribute('aria-label', `slide ${index} of ${slides.length}`);
                el.setAttribute('role', 'group');
            });
        }

        initSlider() {
            const self = this;
            if (this.sliderScrolling != null) {
                const props_marquee = new Flickity(this.sliderScrolling, {
                    accessibility: false,
                    resize: true,
                    wrapAround: true,
                    prevNextButtons: false,
                    pageDots: false,
                    percentPosition: true,
                    setGallerySize: true,
                    contain: true,
                    cellAlign: "left",
                    on: {
                        ready: function () {
                            self.setupSlider(this);
                        }
                    }
                });
                props_marquee.x = 0;
                play();

                function play() {
                    props_marquee.x -= 0.5;
                    props_marquee.settle(props_marquee.x);
                    let requestId = window.requestAnimationFrame(play);
                }
            }

            if (this.slider != null) {
                const isMobileView = window.matchMedia("(max-width: 989px)").matches;
                const sliderGroup = this.slider.hasAttribute('data-group-slider');
                
                const options = {
                    cellAlign: sliderGroup ? "center" : "left",
                    groupCells: sliderGroup , 
                    prevNextButtons: false,
                    pageDots: false,
                    wrapAround: true,
                    selectedAttraction: 0.02,
                    accessibility: false,
                    percentPosition: true,
                    contain: true,
                    autoPlay: isMobileView ? 5000 : false,
                    on: {
                        ready: function () {
                            self.setupSlider(this);
                        }
                    }
                };

                const slider =  new Flickity(this.slider, options);

                if (this.nextSlideToggle != null) {
                    this.nextSlideToggle.addEventListener('click', () => {
                        slider.next(true);
                    })
                }

                if (this.prevSlideToggle != null) {
                    this.prevSlideToggle.addEventListener('click', () => {
                        slider.previous(true);
                    })
                }

                slider.resize()
            }
        }
    })
}

